import React, { useRef, useState, useEffect, useMemo } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import "../styles/navigoDashboardStyles.scss";
import {
  TextField,
  IconButton,
  Modal,
  InputAdornment,
  Radio,
  Menu,
  MenuItem,
} from "@material-ui/core";
import filterApplied from "../../../../../assets/icons/filter-applied-icon.svg";
import goIcon from "../../../../../assets/icons/right_arrow_go_btn.svg";
import funnelIcon from "../../../../../assets/icons/funnel.svg";
import FontIcon from "react-md/lib/FontIcons";
import EventService from "../../../../../service/event/EventService";
import moment from "moment";
import Button from "react-md/lib/Buttons/Button";
import GlobalSkeletonLoader from "../../../../../components/common/GlobalSkeletonLoader";
import NavigoDashboardUtils from "../services/DigitiseDashboardUtils";
import Helper from "util/Helper";
import { TextField as TextField2 } from "react-md";
import { Col } from "react-flexbox-grid";
import PatientTracking from "../../../../ops/modules/patients/modules/tracking/components/PatientTracking";
import PatientsService from "../../../../ops/modules/patients/service/PatientsService";
import UpdateTrackingService from "../../../../ops/modules/patients/modules/new-bridge/components/Update_tracking/service/UpdateTrackingService";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { DialogContainer } from "react-md";
import AccountDashboardUtils from "../../account-module/services/AccountDashboardUtils";

const documentStatus = [
  { value: 1, name: "Reviewed" },
  { value: 2, name: "Not reviewed" },
  { value: 3, name: "Saved as draft" },
  { value: 4, name: "In progress" },
];

function MarginDashboard(props) {
  const [appointmentsList, setAppointmentsList] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuFor, setMenuFor] = useState({});
  const [componentMounted, setComponentMounted] = useState(false);
  const navigoDashboardUtils = new NavigoDashboardUtils();
  const patientService = new PatientsService();
  const updatetrackingservice = new UpdateTrackingService();
  const accountDashboardUtils = new AccountDashboardUtils();
  const helper = new Helper();
  const [patientId, setPatientId] = useState("");
  const [appointmentId, setAppointmentId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [filterObj, setFilterObj] = useState({
    pageNum: 1,
    pageSize: 30,
    sortResults: true,
  });
  const [onlyPageChange, setOnlyPageChange] = useState(false);
  const handleClick = (event, ele) => {
    setAnchorEl(event.currentTarget);
    setMenuFor(ele);
    changeScreen(1, {
      availabilityId: ele.id,
    });
  };

  const [noAppointments, setNoAppointments] = useState(true);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [numFrom, setNumFrom] = useState(0);
  const [numTo, setNumTo] = useState(0);
  const [creationDateFrom, setCreationDateFrom] = useState(null);
  const [creationDateTo, setCreationDateTo] = useState(null);
  const [digitisationDateFrom, setDigitisationDateFrom] = useState(null);
  const [digitisationDateTo, setDigitisationDateTo] = useState(null);
  const [appointmentDateFrom, setAppointmentDateFrom] = useState(null);
  const [appointmentDateTo, setAppointmentDateTo] = useState(null);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openFilter, setOpenFilter] = useState(0);
  const [maxDate, setMaxDate] = useState("");
  const skip = useRef(30);
  const [searchPid, setSearchPid] = useState("");
  const [searchAppid, setSearchAppid] = useState("");
  const [
    filterServiceProviderNameOptions,
    setFilterServiceProviderNameOptions,
  ] = useState([]);
  const [serviceProviderNameOptions, setServiceProviderNameOptions] = useState(
    [],
  );
  const [serviceCodeOptions, setServiceCodeOptions] = useState([]);
  const [filterServiceCodeOptions, setFilterServiceCodeOptions] = useState([]);
  const [accountCodeOptions, setAccountCodeOptions] = useState([]);
  const [filterAccountCodeOptions, setFilterAccountCodeOptions] = useState([]);
  const [filterModesOptions, setFilterModesOptions] = useState([]);
  const [statusFilterValue, setStatusFilterValue] = useState([]);
  const [removeFilters, setRemoveFilters] = useState(false);
  const [digitiseModal, setDigitiseModal] = useState(false);
  const [documentIds, setDocumentIds] = useState([]);
  const [selectedDocumentId, setSelectedDocumentId] = useState(0);
  const [detail, setDetail] = useState([]);
  const [token, setToken] = useState("");
  const [digitiseSuccessModal, setDigitiseSuccessModal] = useState(false);
  const [labTestData, setLabTestData] = useState([]);
  const [subLabTestData, setSubLabTestData] = useState([]);
  const [labPagesData, setLabPagesData] = useState([]);
  const [serviceIdFilterText, setServiceIdFilterText] = useState("");
  const [serviceProviderIdFilterText, setServiceProviderIdFilterText] =
    useState("");
  const [servicePlanIdFilterText, setServicePlanIdFilterText] = useState("");
  const [serviceAccountIdFilterText, setServiceAccountIdFilterText] =
    useState("");
  const isInitialMount = useRef(true);
  const [openRescheduleAppDialog, setOpenRescheduleAppDialog] = useState(false);
  const [appointmentIdTyped, setAppointmentIdTyped] = useState("");
  const [bookSlotAnchorEl, setBookSlotAnchorEl] = useState(null);
  const [noAccount, setNoAccount] = useState(true);

  useEffect(() => {
    if (!props.dashboardFilter) return;

    // apply filter from parent on remount
    setFilterObj({
      ...props.dashboardFilter,
      pageNum: props.dashboardFilter.pageNum || 1,
    });

    setPageNum(props.dashboardFilter.pageNum || 1);

    isInitialMount.current = false;
  }, []);

  useEffect(() => {
    setComponentMounted(true);
    handleFetchAccountCodeOpt("");
  }, []);

  // useEffect(() => {
  //   if (!componentMounted) return;

  //   handleGetAllAppointments();
  // }, [
  //   filterObj.patientIds,
  //   filterObj.appointmentIds,
  //   filterObj.accountCodes,
  //   filterObj.serviceID,
  //   filterObj.serviceProviderID,
  //   filterObj.status,
  //   filterObj.updatedAt,
  //   filterObj.digitisationDate,
  //   filterObj.appointmentDate,
  //   filterObj.pageNum,
  // ]);

  const handleFetchAccountCodeOpt = (str) => {
    accountDashboardUtils.getAccountsByFilter(
      {
        ...filterObj,
        pageNum: 0,
        pageSize: 0,
        accountCodeMatch: [],
        accountCode: str,
      },
      (res) => {
        setOnlyPageChange(false);
        if (res && res.accounts && res.accounts.length > 0) {
          let allList = [];

          allList = res.accounts.map((service) => {
            return { ...service };
          });
          allList = filterUniqueByAccountCode(allList);
          setAccountCodeOptions(allList);
        } else {
          setAccountCodeOptions([]);
        }
      },
      (err) => {
        setLoading(false);
        setNoAccount(true);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  function filterUniqueByAccountCode(arr) {
    const seen = new Map();
    return arr.filter(
      (item) => !seen.has(item.accountCode) && seen.set(item.accountCode, true),
    );
  }

  useEffect(() => {
    if (componentMounted && onlyPageChange == true) {
      setFilterObj({ ...filterObj, pageNum: pageNum });
    }
  }, [onlyPageChange]);
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setMaxDate(today);
  }, []);

  useEffect(() => {
    if (!componentMounted) return;

    skip.current = 30;
    handleGetAllAppointments();
  }, [filterObj, componentMounted]);

  const handleGetAllAppointments = (type = 1, btnType = 0) => {
    setLoading(true);

    navigoDashboardUtils.fetchPlanRules(
      filterObj,
      (res) => {
        setOnlyPageChange(false);
        if (res && res.slotRestrictions && res.slotRestrictions.length > 0) {
          let allList = [];

          allList = res.slotRestrictions.map((service) => {
            return { ...service };
          });
          let localNumFrom, localNumTo;
          if (type === 1) {
            localNumFrom = 1;
            localNumTo = Math.min(30, res.resultCount);
          } else if (type === 2) {
            if (btnType === 0) {
              localNumTo = numFrom - 1;
              localNumFrom = Math.max(numFrom - 30, 1);
            } else {
              localNumFrom = numTo + 1;
              localNumTo = Math.min(numTo + 30, res.resultCount);
            }
          } else if (type === 3) {
            localNumFrom = numFrom;
            localNumTo = numTo;
          }
          setAppointmentsList([...allList]);
          setNoAppointments(false);
          setNumFrom(localNumFrom);
          setNumTo(localNumTo);
          setTotalCount(res.totalCount);
          setLoading(false);
        } else {
          setAppointmentsList([]);
          setNoAppointments(true);
          setLoading(false);
        }
        setRemoveFilters(false);
      },
      (err) => {
        setLoading(false);
        setAppointmentsList([]);
        setNoAppointments(true);
        setRemoveFilters(false);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };
  const changeScreen = (opt, data = null) => {
    if (opt === 1) {
      props.setView(1, data); // ✅ forward data
    }
  };

  const handlePrevNextAppoint = (arg) => {
    setOnlyPageChange(true);
    if (arg) {
      setPageNum((prevPage) => prevPage + 1);
    } else {
      if (pageNum > 1) {
        setPageNum((prevPage) => (prevPage > 1 ? prevPage - 1 : 1));
      }
    }
  };

  // useEffect(() => {
  //   if (!patientId && !appointmentId && !phoneNumber && componentMounted) {
  //     handleGetAllAppointments();
  //   }
  // }, [patientId, appointmentId, phoneNumber]);

  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        status: statusFilterValue.flatMap((e) => [e.value]),
      });
      setPageNum(1);
    }
  }, [statusFilterValue]);

  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        accountCodes: filterAccountCodeOptions.map((e) => {
          return e.accountCode;
        }),
      });
      setPageNum(1);
    }
  }, [filterAccountCodeOptions]);
  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        serviceID: filterServiceCodeOptions.map((e) => {
          return e.id;
        }),
      });
      setPageNum(1);
    }
  }, [filterServiceCodeOptions]);
  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        serviceProviderID: filterServiceProviderNameOptions.map((e) => {
          return e.id;
        }),
      });
      setPageNum(1);
    }
  }, [filterServiceProviderNameOptions]);

  const areFiltersApplied = () => {
    if (
      filterObj?.updatedFrom?.from != null ||
      filterObj?.updatedTo?.to != null ||
      filterObj?.appointmentDate?.from != null ||
      filterObj?.appointmentDate?.to != null ||
      filterObj?.digitisationDate?.from != null ||
      filterObj?.digitisationDate?.to != null ||
      filterObj?.accountCode?.length > 0 ||
      filterObj?.status?.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };
  const resetFilters = () => {
    let resetFilterObj = filterObj;
    delete resetFilterObj.updatedAt;
    delete resetFilterObj.appointmentDate;
    delete resetFilterObj.digitisationDate;
    delete resetFilterObj.accountCode;
    delete resetFilterObj.status;

    setFilterObj({
      ...resetFilterObj,
      pageNum: 1,
    });
    setPageNum(1);
    setOpenFilter(0);
    setOpenBackdrop(false);
  };
  useEffect(() => {
    if (removeFilters === true) {
      setFilterServiceProviderNameOptions([]);
      setFilterServiceCodeOptions([]);
      setFilterAccountCodeOptions([]);
      setFilterModesOptions([]);
      setStatusFilterValue([]);
      resetFilters();
    }
  }, [removeFilters]);
  const formatAccountPlanText = (accountEntities = []) => {
    if (!accountEntities.length) return "-";

    return (
      <>
        {accountEntities.map((acc, index) => (
          <span key={acc.accountCode}>
            (<strong>{acc.accountCode}</strong> - {acc.planIds.join(", ")})
            {index < accountEntities.length - 1 && " "}
          </span>
        ))}
      </>
    );
  };

  const canRescheduleThisAppointment = (appointmentId) => {
    const appointmentIdNumber = Number(appointmentId);
    if (isNaN(appointmentIdNumber) || appointmentIdNumber <= 0) {
      EventService.emit("showError", {
        message: `Please enter a valid appointment ID`,
      });
      return false;
    }

    const onResponse = (res) => {
      if (!res || res.appointments == null || res.totalCount === 0) {
        EventService.emit("showError", {
          message: `Please enter a valid appointment ID`,
        });
      } else if (res && res.appointments && res.appointments.length > 0) {
        const appointment = res.appointments[0];
        if (
          (appointment?.blockRescheduling === true ||
            appointment?.serviceTypeID == 4 ||
            appointment?.status === 2 ||
            appointment?.status === 3 ||
            appointment?.status === 11 ||
            appointment?.status === 12 ||
            appointment?.status === 13 ||
            appointment?.status === 14 ||
            appointment?.status === 15 ||
            appointment?.status === 21) === false
        ) {
          redirectForRescheduleAppointment(appointmentIdNumber);
        } else {
          EventService.emit("showError", {
            message: `This appointment can't be rescheduled`,
          });
        }
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };

    navigoDashboardUtils.fetchAppointmentsWithFilter(
      {
        pageNum: 1,
        pageSize: 1,
        appointmentId: appointmentIdNumber,
      },
      onResponse,
      onError,
    );
  };
  const redirectForRescheduleAppointment = (appointmentId) => {
    props.setView(2, {
      from: "SLOT_RESTRICTION_DASHBOARD",
      appId: appointmentId,
    });
  };

  const closeRescheduleAppDialog = () => {
    setOpenRescheduleAppDialog(false);
    setAppointmentIdTyped("");
  };

  return (
    <>
      <div className="navigo-module-dashboard-table-container">
        <div className="navigo-appoint-container">
          <div className="navigo-appoint-section-8">
            <div
              className="navigo-appoint-section-1"
              onClick={() => {
                helper.navigateTo(props, "/");
              }}
            >
              <FontIcon style={{ fontSize: "36px" }}>arrow_back</FontIcon>
            </div>
            <h1 className="navigo-appoint-section-2">
              Slot restriction dashboard
            </h1>
            <div className="navigo-appoint-section-4-bottom-button-container">
              <Button
                raised
                className={"navigo-module-button-save-enabled1"}
                style={{ marginRight: "8px" }}
                onClick={(event) => {
                  setBookSlotAnchorEl(event.currentTarget);
                }}
              >
                {"Book reserved slot"}
                <FontIcon
                  style={{ marginLeft: "8px", color: "#fff", fontSize: "22px" }}
                >
                  arrow_drop_down
                </FontIcon>
              </Button>
              <Menu
                anchorEl={bookSlotAnchorEl}
                open={Boolean(bookSlotAnchorEl)}
                onClose={() => setBookSlotAnchorEl(null)}
                getContentAnchorEl={null}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <MenuItem
                  onClick={() => {
                    props.setView(3, {
                      from: "SLOT_RESTRICTION_DASHBOARD",
                    });
                    setBookSlotAnchorEl(null);
                  }}
                >
                  Create appointment
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setOpenRescheduleAppDialog(true);
                    setBookSlotAnchorEl(null);
                  }}
                >
                  Reschedule
                </MenuItem>
              </Menu>
              <Button
                raised
                className={"navigo-module-button-save-enabled"}
                style={{ marginRight: "8px" }}
                onClick={() => {
                  changeScreen(1); // ✅ NO availabilityId
                }}
              >
                {"Add new"}
              </Button>
            </div>
          </div>

          <div className="navigo-appoint-section-5">
            <div className="navigo-appoint-section-5-grid-container-margin">
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Service
                  <br /> type &nbsp;
                </p>
              </div>

              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Service <br /> ID
                </p>
                <img
                  src={
                    filterObj?.ServiceIds?.length > 0
                      ? filterApplied
                      : funnelIcon
                  }
                  onClick={() => {
                    setOpenBackdrop(true);
                    setOpenFilter(4);
                  }}
                />
                {openFilter === 4 && (
                  <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup-serviceId">
                    <TextField
                      id="appointment-dialog-client-code-filter-serviceId"
                      className="appointment-dialog-client-code-filter-class"
                      placeholder="Service ID"
                      value={serviceIdFilterText}
                      onChange={(e) => {
                        let inputValue = e.target.value.replace(/[^0-9,]/g, "");

                        setServiceIdFilterText(inputValue);
                      }}
                      inputProps={{
                        maxLength: 20,
                      }}
                      InputProps={{
                        endAdornment: serviceIdFilterText && (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => {
                                setServiceIdFilterText("");
                                let removedFilterObj = { ...filterObj };
                                delete removedFilterObj.ServiceIds;
                                setFilterObj({
                                  ...removedFilterObj,
                                  pageNum: 1,
                                });
                                setPageNum(1);
                              }}
                              edge="end"
                              size="small"
                            >
                              <FontIcon>close</FontIcon>
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <div
                      style={{ display: "flex", cursor: "pointer" }}
                      onClick={() => {
                        if (serviceIdFilterText.trim()) {
                          const ServiceIds = serviceIdFilterText
                            .split(",")
                            .map((id) => id.trim())
                            .filter((id) => id !== "" && !isNaN(id))
                            .map(Number);

                          setFilterObj({
                            ...filterObj,
                            pageNum: 1,
                            ServiceIds,
                          });
                          setPageNum(1);
                        }
                      }}
                    >
                      <img
                        src={goIcon}
                        alt="Go"
                        style={{
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Service <br /> provider Id
                </p>
                <img
                  src={
                    filterObj?.ProviderIds?.length > 0
                      ? filterApplied
                      : funnelIcon
                  }
                  onClick={() => {
                    setOpenBackdrop(true);
                    setOpenFilter(5);
                  }}
                />
                {openFilter === 5 && (
                  <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup-service-providerId">
                    <TextField
                      id="appointment-dialog-client-code-filter-service-providerId"
                      className="appointment-dialog-client-code-filter-class"
                      placeholder="Service Provider ID"
                      value={serviceProviderIdFilterText}
                      onChange={(e) => {
                        let inputValue = e.target.value.replace(/[^0-9,]/g, ""); // Allow only numbers and commas

                        setServiceProviderIdFilterText(inputValue);
                      }}
                      inputProps={{
                        maxLength: 20,
                      }}
                      InputProps={{
                        endAdornment: serviceProviderIdFilterText && (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => {
                                setServiceProviderIdFilterText("");
                                let removedFilterObj = { ...filterObj };
                                delete removedFilterObj.ProviderIds;
                                setFilterObj({
                                  ...removedFilterObj,
                                  pageNum: 1,
                                });
                                setPageNum(1);
                              }}
                              edge="end"
                              size="small"
                            >
                              <FontIcon>close</FontIcon>
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <div
                      style={{ display: "flex", cursor: "pointer" }}
                      onClick={() => {
                        if (serviceProviderIdFilterText.trim()) {
                          const ProviderIds = serviceProviderIdFilterText
                            .split(",")
                            .map((id) => id.trim())
                            .filter((id) => id !== "" && !isNaN(id))
                            .map(Number);

                          setFilterObj({
                            ...filterObj,
                            pageNum: 1,
                            ProviderIds,
                          });
                          setPageNum(1);
                        }
                      }}
                    >
                      <img
                        src={goIcon}
                        alt="Go"
                        style={{
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Creation <br /> date
                </p>
                <img
                  src={
                    filterObj?.createdAt?.from || filterObj?.createdAt?.to
                      ? filterApplied
                      : funnelIcon
                  }
                  onClick={() => {
                    setOpenBackdrop(true);
                    setOpenFilter(3);
                  }}
                />
                {openFilter === 3 && (
                  <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup">
                    <div className="navigo-appointment-date-range-filter ">
                      <p>From</p>
                      <TextField
                        type="date"
                        style={{ width: "90%" }}
                        className="dob"
                        id="dob"
                        onChange={(v) => {
                          if (v.target.value) {
                            setDigitisationDateFrom(v.target.value);
                          }
                        }}
                        // inputProps={{ max: maxDate }}
                        value={digitisationDateFrom}
                      ></TextField>
                    </div>
                    <div className="navigo-appointment-date-range-filter ">
                      <p>To</p>
                      <TextField
                        type="date"
                        defaultValue={""}
                        style={{ width: "90%" }}
                        className="dob"
                        id="dob"
                        onChange={(v) => {
                          if (v.target.value) {
                            setDigitisationDateTo(v.target.value);
                          }
                        }}
                        // inputProps={{ max: maxDate }}
                        value={digitisationDateTo}
                      ></TextField>
                    </div>
                    <Button
                      className=""
                      style={{
                        padding: "3px",
                        margin: "0px 5px",
                        backgroundColor: "#c3c3c3",
                      }}
                      onClick={() => {
                        setFilterObj({
                          ...filterObj,
                          pageNum: 1,
                          createdAt: {
                            from: moment(digitisationDateFrom)
                              .utc()
                              .startOf("day")
                              .add(1, "day")
                              .toISOString(),

                            to: moment(digitisationDateTo)
                              .utc()
                              .endOf("day")
                              .add(1, "day")
                              .toISOString(),
                          },
                        });
                        setPageNum(1);
                        setOpenFilter(0);
                        setOpenBackdrop(false);
                      }}
                    >
                      Go
                    </Button>
                    <Button
                      className=""
                      onClick={() => {
                        let removedFilterObj = filterObj;
                        delete removedFilterObj.createdAt;
                        setFilterObj((prev) => {
                          const copy = { ...prev };
                          delete copy.patientIds;
                          return { ...copy, pageNum: 1 };
                        });
                        setDigitisationDateFrom(null);
                        setDigitisationDateTo(null);
                        setPageNum(1);
                        setOpenFilter(0);
                        setOpenBackdrop(false);
                      }}
                    >
                      <FontIcon className="">close</FontIcon>
                    </Button>
                  </div>
                )}
              </div>
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Service <br />
                  mode
                </p>
              </div>
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <div className="filter-wrapper">
                  <img
                    src={
                      filterAccountCodeOptions.length > 0
                        ? filterApplied
                        : funnelIcon
                    }
                    onClick={() => {
                      setOpenBackdrop(true);
                      setOpenFilter(7);
                    }}
                  />
                  {openFilter === 7 && (
                    <div className="filter-popup-left">
                      <Autocomplete
                        style={{
                          width: "100%",
                          maxHeight: "200px",
                          overflowY: "scroll",
                          overflowX: "hidden",
                        }}
                        multiple
                        id="multiple-limit-acc-name"
                        options={accountCodeOptions}
                        getOptionLabel={(option) => option.accountCode}
                        value={filterAccountCodeOptions}
                        onChange={(e, v) => {
                          if (v) {
                            setFilterAccountCodeOptions(v);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            onChange={(e, v) => {
                              // handleFetchAccountCodeOpt(e.target.value);
                            }}
                            {...params}
                            placeholder=""
                            className="autocomplete-text-field-class"
                          />
                        )}
                      />
                    </div>
                  )}
                </div>
                <p>Account ID - Plan ID</p>
                <div className="filter-wrapper">
                  <img
                    src={
                      filterObj?.planIds?.length > 0
                        ? filterApplied
                        : funnelIcon
                    }
                    onClick={() => {
                      setOpenBackdrop(true);
                      setOpenFilter(6);
                    }}
                  />
                  {openFilter === 6 && (
                    <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup-serviceId">
                      <TextField
                        id="appointment-dialog-client-code-filter-serviceId"
                        className="appointment-dialog-client-code-filter-class"
                        placeholder="Plan ID"
                        value={servicePlanIdFilterText}
                        onChange={(e) => {
                          let inputValue = e.target.value.replace(
                            /[^0-9,]/g,
                            "",
                          );

                          setServicePlanIdFilterText(inputValue);
                        }}
                        inputProps={{
                          maxLength: 20,
                        }}
                        InputProps={{
                          endAdornment: servicePlanIdFilterText && (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => {
                                  setServicePlanIdFilterText("");
                                  let removedFilterObj = { ...filterObj };
                                  delete removedFilterObj.planIds;
                                  setFilterObj({
                                    ...removedFilterObj,
                                    pageNum: 1,
                                  });
                                  setPageNum(1);
                                }}
                                edge="end"
                                size="small"
                              >
                                <FontIcon>close</FontIcon>
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <div
                        style={{ display: "flex", cursor: "pointer" }}
                        onClick={() => {
                          if (servicePlanIdFilterText.trim()) {
                            const planIds = servicePlanIdFilterText
                              .split(",")
                              .map((id) => id.trim())
                              .filter((id) => id !== "" && !isNaN(id))
                              .map(Number);

                            setFilterObj({
                              ...filterObj,
                              pageNum: 1,
                              planIds,
                            });
                            setPageNum(1);
                          }
                        }}
                      >
                        <img
                          src={goIcon}
                          alt="Go"
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>Status</p>
                <img
                  src={
                    filterObj && "active" in filterObj
                      ? filterApplied
                      : funnelIcon
                  }
                  onClick={() => {
                    setOpenBackdrop(true);
                    setOpenFilter(2);
                    // setOpenStatusFilter(true);
                  }}
                />
                {openFilter === 2 && (
                  <div className="mp-service-dashboard-status-filter">
                    <div>
                      <Radio
                        label="active"
                        checked={filterObj.active == true}
                        onClick={() => {
                          setFilterObj({
                            ...filterObj,
                            pageNum: 1,
                            active: true,
                          });
                          setPageNum(1);
                        }}
                      />
                      <label className="label-radio-btn">Active</label>
                    </div>
                    <div>
                      <Radio
                        label="inactive"
                        checked={filterObj.active == false}
                        onClick={() => {
                          setFilterObj({
                            ...filterObj,
                            pageNum: 1,
                            active: false,
                          });
                          setPageNum(1);
                        }}
                      />
                      <label className="label-radio-btn">Inactive</label>
                    </div>

                    <Button
                      className="clear-navigo-booked-for"
                      onClick={() => {
                        let removedFilterObj = filterObj;
                        delete removedFilterObj.active;
                        setFilterObj({
                          ...removedFilterObj,
                          pageNum: 1,
                        });
                        setPageNum(1);
                      }}
                    >
                      Clear
                    </Button>
                  </div>
                )}
              </div>
              {areFiltersApplied() && (
                <div
                  onClick={() => {
                    setRemoveFilters(true);
                  }}
                  style={{
                    display: "inline-block",
                    cursor: "pointer",
                  }}
                >
                  <FontIcon style={{ fontSize: "22px" }}>
                    highlight_remove
                  </FontIcon>
                </div>
              )}
            </div>
          </div>
          <div className="navigo-appoint-section-6">
            {appointmentsList && appointmentsList.length > 0 && (
              <div className="navigo-appoint-bottom-bar">
                <Button
                  className="navigo-appoint-bottom-bar-button"
                  onClick={() => {
                    handlePrevNextAppoint(0);
                  }}
                  disabled={pageNum == 1 || loading}
                >
                  <FontIcon className="navigo-count-icon">
                    arrow_drop_up
                  </FontIcon>
                </Button>
                <div className="navigo-appoint-bottom-bar-text">
                  Showing&nbsp;
                  <span
                    style={{
                      color: "#ef7c01",
                    }}
                  >
                    {(pageNum - 1) * pageSize + 1}&nbsp;- &nbsp;
                    {totalCount > pageNum * pageSize
                      ? pageNum * pageSize
                      : totalCount}
                  </span>
                  <span>&nbsp;of&nbsp;</span>
                  <span>{` ${totalCount}`}</span>
                </div>
                <Button
                  className="navigo-appoint-bottom-bar-button"
                  onClick={() => {
                    handlePrevNextAppoint(1);
                  }}
                  disabled={
                    loading ||
                    pageNum * pageSize > totalCount ||
                    (totalCount > pageNum * pageSize
                      ? pageNum * pageSize
                      : totalCount) == totalCount
                  }
                >
                  <FontIcon className="navigo-count-icon">
                    arrow_drop_down
                  </FontIcon>
                </Button>
              </div>
            )}
            {loading == false && (
              <div className="navigo-appoint-section-6-list">
                {appointmentsList &&
                  appointmentsList.map((ele) => {
                    return (
                      <div
                        className="navigo-appoint-section-6-grid-container-margin"
                        key={ele.id}
                      >
                        <div className="general-font-class ">
                          {"Health checkup"}
                        </div>
                        <div className="general-font-class">
                          {ele.serviceId}
                        </div>

                        <div className="general-font-class ">
                          {ele.providerId}
                        </div>
                        <div className="general-font-class">
                          {ele.createdAt &&
                          ele.createdAt !== "0001-01-01T00:00:00Z"
                            ? moment.utc(ele.createdAt).format("DD MMM YYYY")
                            : "-"}
                        </div>
                        <div className="general-font-class ">{ele.mode}</div>
                        <div className="general-font-class">
                          {formatAccountPlanText(ele.accountEntities)}
                        </div>
                        <div className="navigo-appoint-section-6-grid-status">
                          <div
                            className={`custom-status-display ${
                              ele.active
                                ? "closed-class"
                                : "navigo-appoint-non-select-status-inactive"
                            }`}
                          >
                            {ele.active ? "Active" : "Inactive"}
                          </div>
                        </div>

                        {ele.status != 4 && (
                          <IconButton
                            onClick={(e) => handleClick(e, ele)}
                            className="navigo-appoint-section-6-grid-edit-call"
                          >
                            <InfoOutlinedIcon style={{ color: "#F97F0F" }} />
                          </IconButton>
                        )}
                      </div>
                    );
                  })}
              </div>
            )}

            {loading && <GlobalSkeletonLoader />}
            {loading === false && noAppointments && (
              <div className="no-appointments-container">
                <p>No document found!</p>
              </div>
            )}
          </div>
          {openBackdrop && (
            <div
              className="navigo-appointment-backdrop-class"
              onClick={() => {
                setOpenFilter(0);
                setOpenBackdrop(false);
              }}
            ></div>
          )}
        </div>
      </div>
      {openRescheduleAppDialog && (
        <div className="custom-dialog-overlay">
          <DialogContainer
            id="margin-reschedule-app-dialog"
            visible={openRescheduleAppDialog}
            onHide={() => {
              closeRescheduleAppDialog();
            }}
            focusOnMount={false}
            autosizeContent
            width={"800px"}
            dialogStyle={{
              borderRadius: "10px",
              padding: "15px",
            }}
          >
            <div style={{ fontFamily: "Montserrat", color: "#000" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <h3>Search appointment</h3>
                </div>
                <div>
                  <Button
                    raised
                    disabled={loading}
                    className="navigo-module-button-cancel"
                    onClick={() => {
                      closeRescheduleAppDialog();
                    }}
                  >
                    {"Cancel"}
                  </Button>
                </div>
              </div>

              <br />
              <div style={{ width: "50%" }}>
                <TextField2
                  id={"margin-reschedule-app-dialog-search-input"}
                  lineDirection="left"
                  value={appointmentIdTyped}
                  placeholder="Type here"
                  inlineIndicator={
                    appointmentIdTyped == "" ? (
                      <Button
                        icon
                        style={{
                          margin: "-10px",
                        }}
                        disabled
                      >
                        <FontIcon
                          style={{
                            color: "grey",
                            lineHeight: "0",
                            marginBottom: "15px",
                          }}
                        >
                          arrow_forward
                        </FontIcon>
                      </Button>
                    ) : (
                      <Button
                        icon
                        style={{
                          margin: "-10px",
                          cursor: "pointer",
                        }}
                      >
                        <FontIcon
                          style={{
                            color: "orange",
                            lineHeight: "0",
                            marginBottom: "15px",
                          }}
                          onClick={() => {
                            canRescheduleThisAppointment(appointmentIdTyped);
                          }}
                        >
                          arrow_forward
                        </FontIcon>
                      </Button>
                    )
                  }
                  onChange={(e) => {
                    if (/^\d{0,8}$/.test(e)) {
                      setAppointmentIdTyped(e);
                    }
                  }}
                />
              </div>
            </div>
          </DialogContainer>
        </div>
      )}
    </>
  );
}

export default MarginDashboard;
